const STORAGE_KEY = 'somalive:deletedProducts';
const ADDED_KEY = 'somalive:addedProducts';

interface DeletedProductEntry {
  productId: string;
  id_button: number;
}

export const getDeletedProducts = (): DeletedProductEntry[] => {
  try {
    const stored = sessionStorage.getItem(STORAGE_KEY);
    return stored ? (JSON.parse(stored) as DeletedProductEntry[]) : [];
  } catch {
    return [];
  }
};

export const addDeletedProduct = (productId: string, id_button: number): void => {
  try {
    // Cross-cleanup: se estava pendente de adição, cancelar
    const added = sessionStorage.getItem(ADDED_KEY);
    if (added) {
      const parsed = JSON.parse(added) as Array<{ id?: number; id_button?: number }>;
      sessionStorage.setItem(
        ADDED_KEY,
        JSON.stringify(
          parsed.filter((p) => !(String(p.id) === productId && p.id_button === id_button))
        )
      );
    }

    const existing = getDeletedProducts();
    const alreadyExists = existing.some(
      (p) => p.productId === productId && p.id_button === id_button
    );
    if (!alreadyExists) {
      sessionStorage.setItem(
        STORAGE_KEY,
        JSON.stringify([...existing, { productId, id_button }])
      );
    }
  } catch {
    // sessionStorage pode não estar disponível (ex: modo privado restrito)
  }
};

export const removeDeletedProduct = (productId: string, id_button: number): void => {
  try {
    const existing = getDeletedProducts();
    sessionStorage.setItem(
      STORAGE_KEY,
      JSON.stringify(
        existing.filter((p) => !(p.productId === productId && p.id_button === id_button))
      )
    );
  } catch {
    // sessionStorage indisponível
  }
};

// Chamado após carregar produtos da API: limpa entradas cujo produto já não está mais no cache
export const cleanupConfirmedDeletions = (
  apiProducts: Array<{ id?: number | string }>,
  id_button: number
): void => {
  const deleted = getDeletedProducts().filter((d) => d.id_button === id_button);
  const confirmed = deleted.filter(
    (d) => !apiProducts.some((p) => String(p.id ?? '') === d.productId)
  );
  confirmed.forEach((d) => removeDeletedProduct(d.productId, id_button));
};

export const filterDeletedProducts = <
  T extends { provider?: { productId?: string | number }; id?: string | number }
>(
  products: T[],
  id_button: number
): T[] => {
  const deleted = getDeletedProducts();
  if (!deleted.length) return products;

  return products.filter((product) => {
    const productId = String(product.id ?? '');
    return !deleted.some(
      (d) => d.productId === productId && d.id_button === id_button
    );
  });
};
